import { Button, Dialog } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

interface PaywallModalProps {
  isOpen: boolean;
  invoiceUrl?: string;
}

export const PaywallModal = ({ isOpen, invoiceUrl }: PaywallModalProps) => {
  const { t } = useTranslation();

  const handlePayClick = () => {
    if (invoiceUrl) {
      window.open(invoiceUrl, '_blank');
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => {}} // Intentionally empty - uncloseable modal
      hasCloseButton={false} // Remove close button
    >
      <Dialog.Panel extraClasses="max-h-[80vh] overflow-y-auto">
        <Dialog.Title>{t('paywall.modal.title')}</Dialog.Title>

        {/* Main Content */}
        <div className="space-y-4 pt-4">
          <p>
            <span className="font-bold">{t('paywall.modal.dateText')}</span>
            {t('paywall.modal.description1')}
          </p>
          <p className="font-bold">{t('paywall.modal.description2')}</p>
        </div>

        {/* Payment Button */}
        <div className="flex w-full justify-center py-6">
          <Button primary onClick={handlePayClick} disabled={!invoiceUrl} data-testid="paywall-pay-button">
            {t('paywall.modal.buttonText')}
          </Button>
        </div>

        {/* Thank You Message */}
        <div className="pb-4 text-center">
          <p className="text-sm text-gray-600">{t('paywall.modal.thankYou')}</p>
        </div>

        {/* FAQ Section */}
        <div className="space-y-6 border-t pt-6">
          <h3 className="text-lg font-semibold">{t('paywall.modal.faq.title')}</h3>

          {/* Auto-pay Question */}
          <div className="space-y-2">
            <h4 className="font-semibold">{t('paywall.modal.faq.autoPayQuestion')}</h4>
            <p className="text-sm text-gray-700">
              {t('paywall.modal.faq.autoPayAnswer')}{' '}
              <a href="mailto:support@wonderschool.com" className="text-blue-600 underline hover:text-blue-800">
                {t('email.support.address')}
              </a>
              {t('paywall.modal.faq.autoPayAnswerEnd')}
            </p>
          </div>

          {/* Just Paid Question */}
          <div className="space-y-2">
            <h4 className="font-semibold">{t('paywall.modal.faq.justPaidQuestion')}</h4>
            <p className="text-sm text-gray-700">{t('paywall.modal.faq.justPaidAnswer')}</p>
          </div>

          {/* More Questions */}
          <div className="space-y-2">
            <h4 className="font-semibold">{t('paywall.modal.faq.moreQuestionsQuestion')}</h4>
            <p className="text-sm text-gray-700">
              {t('paywall.modal.faq.moreQuestionsAnswer')}
              <a href="mailto:support@wonderschool.com" className="mx-1 text-blue-600 underline hover:text-blue-800">
                {t('email.support.address')}
              </a>
              {t('paywall.modal.faq.moreQuestionsEnd')}
            </p>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};
